class GlossarySection extends HTMLElement {
  connectedCallback() {
    this.firstLetterList = this.querySelectorAll('.first-letter-js');
    this.categoryButtons = this.querySelectorAll('.category-buttons-js button');

    this.renderItems();

    this.categoryButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        this.categoryButtons.forEach((item) => {
          item.classList.remove('active');
        });
        event.target.classList.add('active');
        this.renderItems();
      });
    });

    document.querySelectorAll('.first-letter-js').forEach(anchor => {
      anchor.addEventListener('click', (event) => {
        event.preventDefault(); 
        const targetId = anchor.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 130, 
            behavior: 'smooth' 
          });
        }
      });
    });
  }

  renderItems() {
    const selectedCategory = this.querySelector('.category-buttons-js .active');
    const selectedCategoryValue = selectedCategory.dataset.category;
    this.glossaryItemsList = this.querySelectorAll('.glossary-item-js');
    this.firstLetterList = this.querySelectorAll('.first-letter-js');

    this.glossaryItemsList.forEach((item) => {
      item.classList.add('hidden');
      if (item.dataset.category === selectedCategoryValue) {
        item.classList.remove('hidden');
      }
    });

    const visibleLetters = new Set();
    this.glossaryItemsList.forEach((item) => {
      if (item.dataset.category === selectedCategoryValue) {
        const firstLetter = item.dataset.firstLetter;
        visibleLetters.add(firstLetter);
      }
    });

    this.firstLetterList.forEach((letter) => {
      if (visibleLetters.has(letter.dataset.firstLetter)) {
        letter.classList.remove('hidden');
      } else {
        letter.classList.add('hidden');
      }
    });
  }
}

customElements.define("glossary-section", GlossarySection);
